import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Calendar as CalIcon, Clock, X } from "lucide-react";

export default function Calendar() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/library/calendar");
      setItems(r.data || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const unschedule = async (id) => {
    await api.post(`/library/${id}/schedule`, { scheduled_at: null });
    toast.success("Unscheduled.");
    load();
  };

  // Group by date
  const groups = {};
  items.forEach((it) => {
    const day = (it.scheduled_at || "").slice(0, 10);
    if (!groups[day]) groups[day] = [];
    groups[day].push(it);
  });
  const dates = Object.keys(groups).sort();

  return (
    <div className="p-6 md:p-10 lg:p-12 space-y-8" data-testid="calendar-page">
      <header className="border-b border-white/10 pb-6">
        <div className="label-eyebrow flex items-center gap-2">
          <CalIcon size={12} className="text-signal-yellow" /> // module 07
        </div>
        <h1 className="heading-display text-4xl sm:text-5xl mt-2">CONTENT <span className="text-signal-yellow">CALENDAR</span>.</h1>
        <p className="font-mono text-xs text-zinc-500 mt-3">// schedule saved hooks + remixes. one queue to rule your posting cadence.</p>
        <p className="font-mono text-[11px] text-zinc-600 mt-2">// tip: schedule any Vault item by tapping the Schedule button on its row.</p>
      </header>

      {loading ? (
        <div className="font-mono text-xs text-zinc-500 animate-pulse">// loading calendar...</div>
      ) : dates.length === 0 ? (
        <div className="brutal-border p-12 bg-[#141414] text-center space-y-3">
          <CalIcon size={32} className="text-signal-yellow mx-auto opacity-60" />
          <div className="font-mono text-xs text-zinc-500">// no scheduled items yet.</div>
          <p className="font-mono text-[11px] text-zinc-600">Go to /app/library → open any item → tap Schedule.</p>
        </div>
      ) : (
        <div className="space-y-6" data-testid="calendar-groups">
          {dates.map((d) => (
            <div key={d} data-testid={`cal-day-${d}`} className="space-y-3">
              <div className="flex items-baseline gap-3">
                <h2 className="heading-display text-xl">{new Date(d + "T00:00:00Z").toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })}</h2>
                <span className="font-mono text-[10px] text-zinc-500 uppercase tracking-wider">{groups[d].length} posts</span>
              </div>
              {groups[d].map((it) => (
                <div key={it.id} data-testid={`cal-item-${it.id}`} className="brutal-border bg-[#141414] p-4 flex items-start justify-between gap-3">
                  <div className="min-w-0 space-y-2 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-mono text-[10px] bg-signal-yellow text-black px-2 py-0.5 uppercase tracking-wider">{it.type}</span>
                      <span className="font-mono text-[10px] text-zinc-500 uppercase tracking-wider">{it.platform}</span>
                      <span className="font-mono text-[10px] text-zinc-600 inline-flex items-center gap-1"><Clock size={10} /> {new Date(it.scheduled_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                    </div>
                    <pre className="font-mono text-xs text-zinc-200 whitespace-pre-wrap break-words line-clamp-3">{it.output || it.input}</pre>
                  </div>
                  <button data-testid={`cal-unschedule-${it.id}`} onClick={() => unschedule(it.id)} className="text-zinc-500 hover:text-signal-red" aria-label="Unschedule">
                    <X size={16} />
                  </button>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
